// extracted by mini-css-extract-plugin
export default {"title":"modal-terms_title__Ujm0K","terms":"modal-terms_terms__C+arb","sub-title":"modal-terms_sub-title__IS79z","content":"modal-terms_content__WJ3vB"};